export const LANDING_MARKETING_ASSET_BASE = '/lsc/marketing';

export const LANDING_FEATURED_REPLAY_ASSET = 'lsc-now-playing.webp';

export const LANDING_FEATURED_REPLAY_ALT =
  'League Stream Center replay player showing a verified Browns at Steelers matchup with embedded watch controls';

export const LANDING_FEATURED_REPLAY_MATCHUP = 'Browns @ Steelers';

export const LANDING_FEATURED_REPLAY_META = 'Week 5 • Season 4 • @cmb_ninob';

export const LANDING_FEATURED_REPLAY_BADGE = 'Verified Replay';

export const LANDING_FEATURED_REPLAY_CTA = 'Watch Replay';

export const LANDING_FEATURED_REPLAY_SUPPORT =
  'Turn league streams into searchable replays, upcoming matchup boards, and a commissioner-controlled media hub.';

export const LANDING_FEATURED_VALUE_CHIPS = [
  'Verified Replay',
  'Searchable Archive',
  'Upcoming Matchups',
  'Commissioner Controlled',
] as const;

export const LANDING_FEATURED_SUPPORT_CARDS = [
  {
    title: 'Watch Live Games',
    description: 'Qualified league streams appear front and center.',
  },
  {
    title: 'Catch Latest Replays',
    description: 'Published VODs become replay cards your members can watch anytime.',
  },
  {
    title: 'Browse League Archives',
    description: 'Find games by week, team, matchup, or broadcaster.',
  },
] as const;

export function landingMarketingAssetUrl(filename: string): string {
  return `${LANDING_MARKETING_ASSET_BASE}/${filename}`;
}

export function landingFeaturedReplayAssetUrl(): string {
  return landingMarketingAssetUrl(LANDING_FEATURED_REPLAY_ASSET);
}
